<div ngbDropdown [container]="'body'" [dropdownClass]="'dropdown-popup'" class="dropdown">
  <a ngbDropdownToggle aria-expanded="false" aria-haspopup="true" class="btn btn-sm bg-main-dark border dropdown-toggle h-auto d-flex align-items-center" href="javascript:;" role="button" *ngIf="item | async as i">
    <img class="current-icon me-1" [src]="i.icon"> ~<ngx-money class="me-1" [value]="i.gas | async" [precision]="i.precision" [disableTooltip]="true"></ngx-money> {{ i.symbol | async }}
  </a>
  <div aria-labelledby="navbarDropdown" class="dropdown-menu dropdown-menu-dark dropdown-menu-fadein" ngbDropdownMenu>
    <a ngbDropdownItem href="javascript:;" class="dropdown-item d-flex align-items-center" (click)="onSelect(item)" *ngFor="let item of items">
      <img class="list-icon" [src]="item.icon">
      <div class="token mx-3">
        <div>
          {{ item.tokenName }}
          <img class="ms-2" src="/retired-zksync/assets/images/icons/tick_20.svg" *ngIf="(paymasterService.key | async) === item.key" />
          <span class="btn btn-outline-success btn-small text-success ms-2 py-0 px-1" *ngIf="item.discount">-{{ item.discount }}%</span>
        </div>
        <div class="text-gray"><ngx-money [value]="item.balance | async" [precision]="item.precision" [disableTooltip]="true"></ngx-money> {{ item.symbol | async }}</div>
      </div>
      <div class="gas ms-auto text-end">
        <div class="d-flex align-items-center justify-content-end">
          <img src="/retired-zksync/assets/images/icons/tabler-icon-gas-station.svg" />&nbsp;~<ngx-money [value]="item.gas | async" [precision]="item.precision" [disableTooltip]="true"></ngx-money>&nbsp;{{ item.symbol | async }}
        </div>
        <div class="text-gray fs-7" [class.invisible]="!item.provider">Powered by {{ item.provider }}</div>
      </div>
    </a>
  </div>
</div>
